module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Illustrations"
    }
  }, [_vm._v("List of illustrations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Abbreviations"
    }
  }, [_vm._v("List of terms and abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Maps"
    }
  }, [_vm._v("Map of operational areas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter_01"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("1")]), _vm._v(" Feeling the War: August 1976")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter_02"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("2")]), _vm._v(" Chiduku, Makoni and Manyika Trifecta: August 1976")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("3")]), _vm._v(" Eastern Border: September–October 1976")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("4")]), _vm._v(" Inyanga, Chiduku Tango: December 1976")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("5")]), _vm._v(" Mantle 151A: February 1977")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("6")]), _vm._v(" Mantle Base Again: Late February 1977")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("7")]), _vm._v(" Wedza Twice: April 1977")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("8")]), _vm._v(" Beitbridge: July 1977")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("9")]), _vm._v(" Chibi Twice: September 1977")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("10")]), _vm._v(" Chiduku Yet Again: January 1978")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("11")]), _vm._v(" Mangwende: March 1978")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("12")]), _vm._v(" Recovery: April–July 1978")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("13")]), _vm._v(" Western Border: August-September 1978")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("14")]), _vm._v(" Interlude: October 1978")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("15")]), _vm._v(" Gutsa: November 1978")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("16")]), _vm._v(" Shot Again: January–June 1979")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("17")]), _vm._v(" Shangaan Army: July-December 1979")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("18")]), _vm._v(" The Final Months: January–May 1980")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-back1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Postscript",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-back"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0